import { Municipality, RequestMunicipality } from "interfaces";
import { get, patch, post, remove } from "services/services.methods";
import { MunicipalityPath } from "services/services.paths";

export const FetchMunicipality = async () => {
  const response = await get<Municipality[]>(MunicipalityPath.basePath);
  return response;
};

export const MunicipalityByDepartament = async (id: number) => {
  const response = await get<Municipality[]>(
    MunicipalityPath.findAllByDepartament + `${id}`
  );
  return response;
};

export const CreateMunicipality = async (
  data: RequestMunicipality
) => {
  const response = await post<Municipality[]>(
    MunicipalityPath.basePath,
    data
  );
  console.log(response, "response function")
  return response;
};

export const UpdateMunicipality = async (
  id: number,
  data: RequestMunicipality
) => {
  const response = await patch<Municipality[]>(
    MunicipalityPath.put + `/${id}`,
    data
  );
  return response;
};

export const DeleteMunicipality = async (id: number) => {
  const response = await remove<Municipality[]>(
    MunicipalityPath.basePath + `/${id}`
  );
  return response;
};
